module.exports = __webpack_public_path__ + "static/media/pin-drop.22944dc5.svg";